import { Injectable } from '@angular/core';

@Injectable()
/**
 * Parse Date
 */
export class DateService {
  constructor() {}

  // Parse from Date: DD MM DD YYYY HH:MM:SS GMT-0500 (CDT) to String: DD/MM/YYYYTHH:00
  parseDateToString(date: Date): String {
    // tslint:disable-next-line:max-line-length
    return (
      date.getFullYear().toString() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate().toString() +
      'T' +
      (date.getHours() < 10
        ? '0' + date.getHours().toString()
        : date.getHours()) +
      ':00'
    );
  }

  setFromHours(date: Date){
    return new Date(date.setHours(23,59,59));
  }

  getSecondsFromDate(date: Date){
    return (date.getHours() * 3600) + (date.getMinutes() * 60) + (date.getSeconds());
  }

  /**
   * Devuelve la diferencia en minutos entre 2 fechas
   * @param dateA 
   * @param dateB 
   * @returns minutos
   */
  getDiffBetweenDates(dateA: Date, dateB: Date): number {
    let fechaInicio = dateA.getTime();
    let fechaFin    = dateB.getTime();

    let diff = fechaFin - fechaInicio;

    return diff / (1000*60);
  }

  getHoursAndMinutes(minutes: number): ITime | null {
    minutes = Math.round(minutes);

    if (minutes < 0) {
      return null;
    }

    let hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    return {
      hours: hours.toString().length <= 1 ? '0'+hours.toString() : hours.toString(), 
      minutes: minutes.toString().length <= 1 ? '0'+minutes.toString() : minutes.toString()
    };
  }
}

//Mover en modal-suggested-date.component.ts
export interface ITime {
    minutes: string;
    hours: string;
}